var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "gt-cursor",
      class: { "gt-cursor--pulsando": _vm.pulsando },
      style: _vm.estiloDoCursor,
      attrs: { "aria-hidden": "true" },
      on: { transitionend: _vm.aoTerminarMovimento }
    },
    [
      _c(
        "svg",
        {
          staticClass: "gt-cursor__svg",
          attrs: {
            width: "26",
            height: "26",
            viewBox: "0 0 26 26",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            focusable: "false"
          }
        },
        [
          _c("circle", {
            staticClass: "gt-cursor__ripple",
            attrs: {
              cx: "4",
              cy: "4",
              r: "7",
              fill: "none",
              stroke: "var(--primary)",
              "stroke-width": "2"
            }
          }),
          _c("g", { staticClass: "gt-cursor__seta" }, [
            _c("polygon", {
              attrs: {
                points: "0,0 14,14 8,14 8,22 5,22 5,14 0,20",
                fill: "var(--neutral-900)",
                stroke: "var(--white)",
                "stroke-width": "1.5",
                "stroke-linejoin": "round"
              }
            })
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }